'use client'

import { createContext } from 'react'

import { UiState } from '@marketplace-web/shared/ui-state-util'
import {
  Conversation,
  ConversationMessage,
  TransactionModel,
} from '@marketplace-web/messaging/conversation-messaging-data'

import { HttpStatus } from '@marketplace-web/core-api/api-client-util'

import {
  GetConversationRequestArgs,
  TranslateConversationArgs,
  SendMessageUiState,
} from './ConversationContext.types'

export type ConversationContextType = {
  conversation: Conversation | undefined
  conversationUiState: UiState
  conversationRequestStatus: HttpStatus | null
  getConversationRequest: ({ conversationId, fromPostReply }: GetConversationRequestArgs) => void
  setConversation: (conversation: Conversation) => void
  setTransaction: (transaction: TransactionModel) => void
  conversationError: string | null
  clearConversation: () => void
  translateConversationRequest: (args: TranslateConversationArgs) => void
  transactionUiState: UiState
  transaction: TransactionModel | null
  conversationMessages: Array<ConversationMessage>
  setConversationMessages: (messages: Array<ConversationMessage>) => void
  sendMessageUi: SendMessageUiState
  setSendMessageUi: (uiState: SendMessageUiState) => void
  isFirstTimeListerEducationDialogVisible: boolean
  setIsFirstTimeListerEducationDialogVisible: (isVisible: boolean) => void
  conversationLoadStartForEscrowOrderABTest: number
  setConversationLoadStartForEscrowOrderABTest: (value: number) => void
}

export const ConversationContext = createContext<ConversationContextType | null>(null)

export default ConversationContext
